import * as React from "react";
import * as Flex from "@twilio/flex-ui";
import { updateTaskContexts } from "./Actions/CannedResponsesActions";
import uhaulStore from "../CustomRedux/UhaulStore";
import ExceptionLogger from "../ExceptionHelper";
import { Button } from "@twilio/flex-ui";
import { Box } from "@twilio/flex-ui/node_modules/@twilio-paste/box";
import { Text } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/text";
import { Manager } from "@twilio/flex-ui";
import { sendMessage } from "./Actions/CommonActions"
import GetLiveChatHeader from "../LiveChatHeaderHelper";
import LeaveChatButton from "../Features/feature-library/conversation-transfer/custom-components/LeaveChatButton"
import ChatTransferService from "../Features/feature-library/conversation-transfer/helpers/APIHelper";
import parkingState from "../Features/feature-library/conversation-transfer/helpers/parkingState";

/*11/30/18 - C Lam - Task #451325: Live Chat - End Monitoring Ends Customer's Chat */
export class SupervisorActionPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            serviceBaseUrl: uhaulStore.getState().UhaulReducer.config.serviceBaseUrl,
            hasBeenBarged: null,
            joinChatSuccessful: null,
            conversation: null,
            participantsCount: 0
        }
    }

    async componentDidMount() {
        try{
            const client = Manager.getInstance().conversationsClient;
            if (client && this.props.task && this.props.task.attributes && this.props.task.attributes.conversationSid){
                var conversation = await client.getConversationBySid(this.props.task.attributes.conversationSid);
                if (conversation){
                    conversation.on("participantLeft", this.handleParticipantUpdate);
                    conversation.on("participantJoined", this.handleParticipantUpdate);
                    conversation.on("updated", this.handleConversationUpdate);
                }
            }
            this.checkIfSupervisorInChat(this.props.task);
        } catch (err) {
            console.error("Component Mount Error: ", err);
            ExceptionLogger(err, "componentDidMount", "Error mounting SupervisorActionPanel", "", this.state.serviceBaseURL);
        }
    }

    componentWillUnmount() {
        try{
            const { conversation } = this.state;

            // Remove the event listener when the component unmounts
            if (conversation) {
                conversation.removeListener("participantJoined", this.handleParticipantUpdate);
                conversation.removeListener('participantLeft', this.handleParticipantUpdate);
                conversation.removeListener("updated", this.handleConversationUpdate);
            }
        } catch (err) {
            console.error("Component Unmount Error: ", err);
            ExceptionLogger(err, "componentWillUnmount", "Error while unmounting SupervisorActionPanel", "", this.state.serviceBaseURL);
        }
    }

    handleConversationUpdate = (response) => {
        try{
            if (response && response.conversation){
                this.setState({conversation: response.conversation});
            }
        }catch (err) {
            console.error("handleConversationUpdate Error: ", err);
            ExceptionLogger(err, "handleConversationUpdate", "Error while updating conversation supervisor count", "", this.state.serviceBaseURL);
        }
    }

    handleParticipantUpdate = async (payload) => {
        try {
            if (payload.conversation && payload.conversation._participants && payload.conversation._participants.size){
                this.setState({ participantsCount: payload.conversation._participants.size});
                //Should handle situation when person leaves the chat outside of supervisor panel
                if (payload.conversation._participants.size < 3){
                    await parkingState.waitForParkingToFinish(payload.conversation.sid);

                    const client = Manager.getInstance().conversationsClient;
                    var conversation = await client.getConversationBySid(this.props.task.attributes.conversationSid);
                    if (conversation){
                        const conversationResponse = await conversation.updateAttributes({
                            ...conversation.attributes,
                            supervisorCount: 0
                        });
                        this.setState({ conversation: conversationResponse });
                    }
                }
            }
        } catch (err) {
            console.error("handleParticipantUpdate Error: ", err);
            ExceptionLogger(err, "handleParticipantUpdate", "Error while updating participant count", "", this.state.serviceBaseURL);
        }
    }

    checkIfSupervisorInChat = async (task) => {
        try {
                const client = Manager.getInstance().conversationsClient;
                if (!client || !task || !task.attributes || !task.attributes.conversationSid){
                    console.error("Missing required fields for checkIfSupervisorInChat.")
                    return;
                }
                const conversation = await client.getConversationBySid(task.attributes.conversationSid);
                
                if (conversation) {
                    this.setState({ conversation });
                    const participants = await conversation.getParticipants();
                    const currentUserIdentity = Manager.getInstance().user.identity;
                    if (!participants || !currentUserIdentity) {
                        this.setState({ joinChatSuccessful: false });
                        return;
                    }
                    if (participants.length){
                        this.setState({ participantsCount: participants.length});
                    }
                    const isInChat = await this.isWorkerInParticipants(participants, currentUserIdentity);
                    if (isInChat) {
                        this.setState({ joinChatSuccessful: true, conversation });
                    } else {
                        this.setState({ joinChatSuccessful: false });
                    }
                }
        } catch (err) {
            console.error("checkIfSupervisorInChat Error: ", err);
            ExceptionLogger(err, "checkIfSupervisorInChat", "Error checking if supervisor in chat", "", this.state.serviceBaseURL);
        }
      };

      isWorkerInParticipants = async (participants, workerSid) => {
        try {
            if (!participants || !workerSid || participants.length === 0) {
                return false;
            }
            for (const participant of participants) {
                const participantUser = await participant.getUser();
                if (participantUser && participantUser.identity && participantUser.identity === workerSid) {
                    return true;
                }
            }
        } catch (err) {
            console.error("isWorkerInParticipants Error: ", err);
            ExceptionLogger(err, "isWorkerInParticipants", "Error checking if worker in participants", "", this.state.serviceBaseURL);
        }
        return false;
      };


    endChat = async (task) => {
        try
        {
            const serviceBaseURL = this.state.serviceBaseUrl;
            const token = Manager.getInstance().user.token;
            const conversationSid = task.attributes.conversationSid;
            if (!conversationSid) {
                console.error("error building endChatAPIPayload");
                //Assume its a general task and not a conversation task (i.e mobile advantage)
                if (token && task && task.taskSid){
                    fetch(serviceBaseURL + "task-end-chat", {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        method: "POST",
                        body: new URLSearchParams({
                            Token: token,
                            taskSid: task.taskSid,
                            reason: "Supervisor ended chat."
                        })
                        })
                        .then((response) => {
                            if (response && response.status != 200) {
                            ExceptionLogger(
                                response,
                                "SupervisorActionPanel.js",
                                "Error with Supervisor End Chat",
                                "",
                                ""
                            );
                            }
                        }).catch((error) => {
                            console.error(error);
                            ExceptionLogger(
                                error,
                                "SupervisorActionPanel.js",
                                "Error with Supervisor End Chat",
                                "",
                                ""
                                );
                    });
                }
                return;
            };

            const endChatAPIPayload = {
                conversationSid
            };

            const manager = Manager.getInstance();
            try {
                await new ChatTransferService(manager).endAllChatsRequest(endChatAPIPayload);                
            }
            catch (error) {
                console.error("end chat API request failed", error);
                await new ChatTransferService(manager).endAllChatsRequest(endChatAPIPayload);                
            }
        }
        catch (err) {
            console.error("end chat API request failed in general", err);
        }
    };


    joinChat = async (task) => {
        try {
          if (!task || !task.attributes || !task.attributes.conversationSid){
            console.error("Missing required fields for joinChat.")
            return;
          }
          const serviceBaseURL = this.state.serviceBaseUrl;
          const token = Manager.getInstance().user.token;
          const currentUser = uhaulStore.getState().UhaulReducer.currentUser;
          const conversationSid = task.attributes.conversationSid;
          if (conversationSid) {
            const client = Manager.getInstance().conversationsClient;
            if (client){
                const conversation = await client.getConversationBySid(task.attributes.conversationSid);
                if (conversation) {
                    this.setState({conversation});
                    if (conversation.attributes){
                        conversation.updateAttributes({
                            ...conversation.attributes,
                            supervisorCount: 1,
                        }
                        );
                    }
                }
            }
          }
          const author = uhaulStore.getState().UhaulReducer.currentUser.friendlyName;
          const flexInteractionChannelSid = task.attributes.flexInteractionChannelSid;
          const flexInteractionSid = task.attributes.flexInteractionSid;
          const workersid = currentUser.sid;
          const allQueues = uhaulStore.getState().UhaulReducer.allQueues;
          if (!allQueues || !task?.attributes?.type) {
            // Handle the case where allQueues or task attributes are not available
            console.error("Missing required data for joinChat.");
            return;
          }
          const queueMatch = allQueues.find(
            (queueItem) => queueItem.Type.toLowerCase().trim() === task.attributes.type.toLowerCase().trim()
          );
          const body = "Supervisor Joined";
          return new Promise((resolve) =>
            setTimeout(
              () =>
                resolve(
                  fetch(serviceBaseURL + "add-agent", {
                    headers: {
                      "Content-Type": "application/x-www-form-urlencoded"
                    },
                    method: "POST",
                    body: new URLSearchParams({
                      Token: token,
                      flexInteractionChannelSid: flexInteractionChannelSid,
                      flexInteractionSid: flexInteractionSid,
                      workerSid: workersid,
                      queueSid: queueMatch.Id,
                      attributes: JSON.stringify(task.attributes)
                    })
                  })
                    .then((response) => {
                      if (response && response.status === 200) {
                        sendMessage(conversationSid, author, body);
                        this.setState({ joinChatSuccessful: true });
                      } else {
                        throw response;
                      }
                    })
                    .catch((err) => {
                      console.log("Fetch ERROR: ", err);
                      ExceptionLogger(
                        err,
                        "Index.js",
                        "Error with UpdateTask",
                        "",
                        `${payload.task.attributes.channelSid}`
                      );
                    })
                ),
              100
            )
          );
        } catch (err) {
            console.error("joinChat Error: ", err);
            ExceptionLogger(serviceBaseURL, err, "joinChat", "Error with Promise", "", `taskSid=${taskSid}`);
        }
      };

    closeBargedChat = (task) => {
        var serviceBaseURL = this.state.serviceBaseUrl;
        var closeButton =  document.querySelector(".Twilio-SupervisorTaskCanvas .Twilio-Icon-Close").click()

        if (window.confirm("Are you sure you want to end the chat?")) {
            this.endChat(task)
                .then(() => {
                    if(closeButton){
                        closeButton.click();
                    }
                }).catch((err) => {
                    console.log("Fetch ERROR: ", err);
                    ExceptionLogger(serviceBaseURL, err, "endChat", "Error with Promise", "",`taskSid=${task?.taskSid}`);
                });
        }
    }

    handleLeaveChatComplete = async () => {
        try {
            this.setState({ joinChatSuccessful: false });
            
            if (this.props && this.props.task && this.props.task.attributes && this.props.task.attributes.conversationSid){
                const client = Manager.getInstance().conversationsClient;
                var conversation = await client.getConversationBySid(this.props.task.attributes.conversationSid);
                if (conversation){
                    const conversationResponse = await conversation.updateAttributes({
                        ...conversation.attributes,
                        supervisorCount: 0
                    });
                    this.setState({ conversation: conversationResponse });
                }
            }
        } catch (err) {
            console.error("handleLeaveChatComplete Error: ", err);
            ExceptionLogger(err, "handleLeaveChatComplete", "Error updating state after leaving chat", "", this.state.serviceBaseURL);
        }
    };

    render() {
        var taskContexts = uhaulStore.getState().UhaulReducer.currentTaskContext;

        if (taskContexts?._task == null || this.props.task?._task?.sid !== uhaulStore.getState().UhaulReducer.currentTaskContext?._task?.sid) {
            uhaulStore.dispatch(updateTaskContexts(this.props.task));
        }

        if (this.props && this.props.task && this.props.task.attributes && this.props.task.status !== "reserved")
        {
            var isBargeButtonShowing = document.getElementById("btnBarge");
            var anotherSupervisorBarging = document.getElementById("btnBargeFeedback");

            return(<Box className="customTwilioDivStyle">
                    {(!anotherSupervisorBarging) && ((isBargeButtonShowing == null) || taskContexts.isBarging || taskContexts.isBargedOn) ?
                        <Button className="Twilio-EndButton Twilio-TaskCanvasHeader-EndButton customTwilioBtn right" onClick={(e) => { this.closeBargedChat(this.props.task); e.preventDefault(); }}>
                            <Text className="">End Chat</Text>
                        </Button> : null}
                        {this.state.joinChatSuccessful != null && !this.state.joinChatSuccessful && (this.state.conversation == null || (this.state.conversation && this.state.conversation.attributes != null && (!this.state.conversation.attributes.supervisorCount || this.state.conversation.attributes.supervisorCount == 0))) && (
                            <Button
                                className="Twilio-JoinButton Twilio-TaskCanvasHeader-JoinButton customTwilioBtn left"
                                onClick={(e) => {
                                    this.joinChat(this.props.task);
                                    e.preventDefault();
                                }}
                            >
                                <Text className="">Join Chat</Text>
                            </Button>
                        )}
                        {this.state.joinChatSuccessful && this.state.conversation && this.state.participantsCount > 2 && (
                            <LeaveChatButton conversation={this.state.conversation} size="medium" onLeaveChatComplete={() => this.handleLeaveChatComplete()}/>
                        )}
                    </Box>)
        }
        else {
            return (<Box className="loadingMonitorBtn">
            </Box>)
        }
    }
}
